export default __webpack_public_path__ + "static/1-981610c7c8823af83103881d8cbf6c72.mp4";